<template>
  <section class="py-3">
    <span v-show="type != 'see'">
    <label
      :for="'file-' + fileType"
      class="v-btn v-btn--depressed v-btn--flat v-btn--outlined theme--light v-size--default blue--text"
    >
      <v-icon small class="mr-3 blue--text">mdi-upload</v-icon>
      {{ type == 'edit' ? "Заменить файл" : $t('buttons.selectFile') }} 
    </label>
    <v-icon
      v-if="this.masFiles.length > 0"
      class="blue--text"
      @click="deleteFiles"
      >mdi-trash-can-outline</v-icon
    >
    </span>
    <div v-if="errorMessage" class="red--text py-3">
      <v-icon small class="red--text">mdi-alert-circle-outline</v-icon>
      {{ errorMessage }}
    </div>

    <div v-for="item in masFiles" :key="item.fileName" class="grey--text py-3">
      <v-icon small class="grey--text">mdi-file</v-icon>
      {{ item.fileName }}
    </div>

    <input
      :id="'file-' + fileType"
      @change="changed"
      type="file"
      class="file"
      multiple
    />
  </section>
</template>
<script>
export default {
  props: [
    // data
    "fileType",
    // settings
    "income",
    "file",
  ],
  data: () => ({
    // data
    fileSourceUrl: null,
    fileName: null,
    fileBytes: null,
    fileGuid: null,
    // settings
    errorMessage: null,
    type:null,
    masFiles: [],
  }),
  created() {
    let {type} = this.$route.query;
    this.type = type;
  },
  methods: {
    transferData() {
      this.$emit("transferData", {
        /* fileType: this.fileType,
          fileSourceUrl: this.fileSourceUrl,
          fileName: this.fileName,
          fileBytes: this.fileBytes,
          fileGuid: this.fileGuid */
        masFiles: this.masFiles,
        fileType: this.fileType,
      });
    },
    fillPresetData(payload) {
      let keys = Object.keys(payload).filter((i) => i !== "fileType");
      keys.forEach((key) => {
        this[key] = payload[key];
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () =>
          resolve(reader.result ? reader.result.replace(/data.*,/, "") : "");
        reader.onerror = (error) => reject(error);
      });
    },

    deleteFiles() {
      this.masFiles = [];
      this.errorMessage = false;
      this.transferData();
    },

    changed(payload) {

      if(this.type && this.type == 'edit')
      {
        this.deleteFiles();
      }
      //    this.masFiles.length = 0;

      if (payload.target.files.length + this.masFiles.length > 10) {
        this.errorMessage =
          this.$t('rules.maxCountFiles');
        return;
      }

      let files = payload.target.files;
      let availableSize1 = 20 * 1024 * 1024;
      let sumOfSizes = 0;

      for (let i = 0; i < files.length; i++) {
        sumOfSizes += files[i].size;
        //tyt zdelyam return
        if(files[i].size == 0){
          this.errorMessage = this.$t('rules.zeroKB');
          return;
        }
      }

      for (let i = 0; i < this.masFiles.length; i++) {
        sumOfSizes += this.masFiles[i].fileSize
      }

      if (sumOfSizes > availableSize1) {
        this.errorMessage = this.$t('rules.maxSize20MB');
        return;
      } else {
        this.errorMessage = false;
      }

      let file = payload.target.files[0];

      for (let i = 0; i < files.length; i++) {
        if (!files[i]) {
          this.errorMessage = this.$t('rules.readError');
          return;
        }

        if (files[i].name.length >= 128) {
          this.errorMessage = `${this.$t('rules.fileNameLength128')} ${file.name}`;
          return;
        }

        // Проверка на тип файла
        let availableFormats = [
          "jpg",
          "jpeg",
          "doc",
          "docx",
          "tiff",
          "gif",
          "pdf",
          "bmp",
        ];

        if (
          !availableFormats.some((item) => {
            return files[i].type.indexOf(item) > 0;
          })
        ) {
          this.errorMessage = this.$t('rules.invalidFormat') + " " + files[i].type;
          return;
        }

        this.getBase64(files[i])
          .then((response) => {
            let fileInfo = {
              fileName: files[i].name,
              fileBytes: response,
              fileSize: files[i].size,
            };

            if(!(this.masFiles.filter(x=> x.fileName == fileInfo.fileName).length > 0))
              this.masFiles.push(fileInfo);
          })
          .catch((err) => {
            this.errorMessage = err;
          });
      }
      this.transferData();
    },
  },
  watch: {
    income: {
      immediate: true,
      handler: function (value) {
        if (value !== null) {
          this.fillPresetData(value);
        }
      },
    },
  },
};
</script>

<style scooped>
input[type="file"] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
</style>
